import { ISODateTimeString } from "@buzzeasy/shared-frontend-utilities";
import { Participant, TranscriptHistoryItem } from "./hubDtos";

export interface SimplifiedTranscriptItem {
  id: string;
  timestamp: ISODateTimeString;
  senderType: Participant;
  text: string;
}

export interface NextBestActionRequest {
  transcript: SimplifiedTranscriptItem[];
}

export interface NextBestActionResponse {
  answer: string;
}

export interface AgentAssistConfig {
  id: string;
  name: string;
  instructions: string;
  knowledgeBaseId: string | null;
  confidenceThreshold: number | null;
  isReactive: boolean;
  shortcuts: QuickResponse[];
}

export interface QuickResponse {
  id: string;
  displayName: string;
  instruction: string;
}

export function mapToSimplifiedItem(item: TranscriptHistoryItem): SimplifiedTranscriptItem {
  return {
    id: item.id,
    timestamp: item.timeStampUtc,
    senderType: item.source.participant,
    text: item.source.participant === "Customer"
      ? (item.translatedText ?? item.text)
      : item.text,
  };
}
